import angular from 'angular';
import uiRouter from 'angular-ui-router';
import taxationClosingsComponent from './closings.component';


const taxationClosingsModule = angular.module('tinaba.components.taxation.closings', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('taxation.closings', {
      url: '/closings',
      template: '<closings></closings>'
    });
})

.component('closings', taxationClosingsComponent);

export default taxationClosingsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/closings/closings.js
 **/